import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useDebounce } from "utils";
import {
  workingPeriodStatus,
  changeArrayToWeekDay,
  gender,
} from "utils/common";
import { Input, Button } from "antd";
import styled from "@emotion/styled";
import { useJobDetail, useApplyJob } from "utils/job-public";

export const PublicApplyJobScreen = () => {
  const { uuid } = useParams();
  const [param, setParam] = useState({ uuid: uuid });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const [submitData, setSubmitData] = useState({
    uuid: uuid,
    phone: "",
  });

  const { data: jobData, retry } = useJobDetail(useDebounce(param, 200));

  const {
    mutate,
    isLoading,
    isError,
    isSuccess,
    data: applyResult,
  } = useApplyJob();

  const handleChange = (e: { target: { name: string; value: string } }) => {
    const { name, value } = e.target;
    setSubmitData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!submitData.phone) {
      return alert("please enter a phone number");
    }

    await mutate(submitData);
  };

  useEffect(() => {
    if (isSuccess && applyResult) {
      alert("the application was successfully submitted");

      setIsSubmitted(true);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      alert("You cannot apply for this job, please contact 98675230");
    }
  }, [isError]);

  return (
    <Container>
      {true ? (
        <>
          <HeaderContainer>
            <h1>UniCare360</h1>
            <h2>job offers</h2>
          </HeaderContainer>

          <RowContainer>
            <b>job number:</b> {jobData?.taskNo}
          </RowContainer>

          <RowContainer>
            <b>job period:</b> {workingPeriodStatus(jobData?.workingPeriod)}
          </RowContainer>

          <RowContainer>
            <b>start date:</b> {jobData?.startDate}
          </RowContainer>

          <RowContainer>
            <b>start time:</b> {jobData?.startTime}
          </RowContainer>

          <RowContainer>
            <b>working hours:</b> {jobData?.workingHours}小時
          </RowContainer>

          <RowContainer>
            <b>week:</b> {changeArrayToWeekDay(jobData?.week)}
          </RowContainer>

          <RowContainer>
            <b>address:</b> {jobData?.address}
          </RowContainer>

          <RowContainer>
            <b>client:</b>{" "}
            {jobData?.employer?.type === 1
              ? jobData?.employer?.companyName
              : `${gender(jobData?.employer?.patientGender)}, age: ${
                  jobData?.employer?.patientAge
                }, height: ${jobData?.employer?.patientHeight}cm, weight: ${
                  jobData?.employer?.patientWeight
                }kg`}
          </RowContainer>

          <RowContainer>
            <b>work notes:</b> {jobData?.description}
          </RowContainer>

          <RowContainer>
            For enquiries, please call/
            <a
              href={`https://wa.me/+85298675630/?text=I would like to enquire about the details of the job, job number:${jobData?.taskNo}`}
              target="_blank"
              rel="noreferrer"
            >
              whatsApps
            </a>
            ：98675630, if you don t have time to pick up the above jobs, Please take the trouble to forward it to interested friends/colleagues, thank you🙇‍♀
          </RowContainer>

          {isSubmitted ? (
            <FormContainer>
              <h3 style={{ paddingTop: 30 }}>applied for a job</h3>
            </FormContainer>
          ) : (
            <FormContainer>
              <FormTitle>enter your phone number to apply for a job</FormTitle>
              <Input
                placeholder="enter a phone number"
                name="phone"
                value={submitData.phone}
                onChange={handleChange}
              />
              <Button
                type="primary"
                onClick={() => handleSubmit()}
                style={{ marginTop: 20 }}
              >
                apply for a job
              </Button>
            </FormContainer>
          )}
        </>
      ) : (
        <h2>this job is not open for applications</h2>
      )}
    </Container>
  );
};

const Container = styled.div`
  padding: 5rem 10px;
  width: 350px;
  margin: 0 auto;
`;

const HeaderContainer = styled.div`
  text-align: center;
  padding-bottom: 20px;
`;

const RowContainer = styled.div`
  padding-bottom: 10px;
`;

const FormContainer = styled.div`
  text-align: center;
`;

const FormTitle = styled.div`
  padding-top: 10px;
  padding-bottom: 5px;
  font-weight: bold;
`;
